// [guanxing patch] M-SW15：本命星命数据档（出生时刻 → 星座/星次/本命宿/本命星君）。
// 纯本地静态数据 + 纯函数，无外网依赖。黄经值均为 J2000 黄道坐标（度）。
//
// 【二十八宿边界口径】宿区间 = 本宿距星黄经 → 次宿距星黄经（传统宿序）。
// 距星取现代通用口径（与 d3-celestial 图形首星、星表别名双重印证）：
// 角=α Vir(Spica)、亢=κ Vir、氐=α Lib、房=π Sco、心=σ Sco、尾=μ¹ Sco、
// 箕=γ Sgr(Alnasl)、斗=φ Sgr、牛=β Cap(Dabih)、女=ε Aqr(Albali)、
// 虚=β Aqr(Sadalsuud)、危=α Aqr(Sadalmelik)、室=α Peg(Markab)、壁=γ Peg(Algenib)、
// 奎=η And、娄=β Ari(Sheratan)、胃=41 Ari(Bharani)、昴=17 Tau(Electra)、
// 毕=ε Tau(Ain)、觜=λ Ori(Meissa)、参=ζ Ori(参宿一 Alnitak)、井=μ Gem(Tejat)、
// 鬼=θ Cnc、柳=δ Hya、星=α Hya(Alphard)、张=υ¹ Hya、翼=α Crt(Alkes)、轸=γ Crv。
// 参距星取参宿一（ζ Ori，λ=84.68°）而非参宿三（δ Ori，λ=82.36°）：如此觜宿
// 区间 0.97°≈古距度「觜半度」、参宿 10.6°≈「参十度」，且全部 28 边界沿传统
// 宿序单调递增（觜参不倒置），区间判定无需特判。误差来源：岁差使古典赤道
// 距度与现代黄经宽度有数度级漂移，本表为现代黄经口径。
//
// 【本命星君】二十八宿星君通行名（五行 + 七曜禽兽，如《西游记》二十八宿）。
// 【十二星次】太阳黄经按二十四节气每两节气一次：星纪起大雪(255°)，
// 各次起点 = 节气黄经，与西方占星十二宫的对应关系见 sign 字段（占星口径，
// 与 App.vue ZODIAC_SIGNS 同一日期表；天文上太阳实际位置存在岁差漂移）。
//
// [guanxing patch] M-SW53（用户需求「星次/本命星君要自己独特的文化知识介绍，
// 星座介绍添加独属于这个星座的介绍」）：
//  - LUNAR_MANSIONS 增 sum（宿一句话摘要）/ lordSum（星君一句话）/ lordLore（星君文化注）；
//  - XINGCI 增 qi（太阳行经节气区间）/ sum（一句话摘要）/ lore（星次文化注）；
//  - 新增 ZODIAC_SUMMARY（十二星座一句话独属摘要，键为 ZODIAC_SIGNS 中文名）。
// 全部由本仓库按传统文化口径自撰，零外网依赖；星宿长文与古画仍在
// skydata/lore/chinese-28.json（build-lore.mjs 产物），两条数据线互补不重叠。

export const LUNAR_MANSIONS = [
  {
    name: '角',
    lord: '角木蛟',
    group: '东方青龙',
    from: 203.841,
    obj: 'CON chinese-28 009',
    sum: '二十八宿之首，两星如龙角，主造化万物、布君威信。',
    lordSum: '东方青龙首宿星君，木蛟之精，主两角造化。',
    lordLore: '二十八宿星君是道教为二十八宿配祀的神格，名号由「宿名+五行+七曜禽兽」构成。蛟为无角之龙、得水而升——木蛟居青龙之首，取龙角初生、春木萌动之意。'
  },
  {
    name: '亢',
    lord: '亢金龙',
    group: '东方青龙',
    from: 214.494,
    obj: 'CON chinese-28 011',
    sum: '青龙之颈，四星高亢，主天庭政令与冤讼。',
    lordSum: '东方青龙次宿星君，金龙之精，居高亢天位。',
    lordLore: '亢为咽喉要地，居「亢龙有悔」之高极。金龙盘于颈位，金性肃杀、龙性威严，占「天子内朝、天下礼官」之事。'
  },
  {
    name: '氐',
    lord: '氐土貉',
    group: '东方青龙',
    from: 225.083,
    obj: 'CON chinese-28 004',
    sum: '青龙胸膺，四星如床榻根基，主根本与疫疠。',
    lordSum: '东方青龙第三宿星君，土貉之精，主胸膺根基。',
    lordLore: '氐即「根柢」，是龙身承上启下的胸位。土貉穴居而能载物，土性厚重，占「道路津梁、根本固否」之事。'
  },
  {
    name: '房',
    lord: '房日兔',
    group: '东方青龙',
    from: 242.94,
    obj: 'CON chinese-28 006',
    sum: '青龙之腹，四星如驾车四马，主天驷明堂。',
    lordSum: '东方青龙第四宿星君，日兔之精，主天驷明堂。',
    lordLore: '房宿四星直排如驾，古称「天驷」，是天子车驾之象。日兔属阳精而性捷，兔为望月而生之兽，取「明堂布政、光被四表」意。'
  },
  {
    name: '心',
    lord: '心月狐',
    group: '东方青龙',
    from: 247.8,
    obj: 'CON chinese-28 022',
    sum: '青龙之心，三星中央大火星，天王正位。',
    lordSum: '东方青龙第五宿星君，月狐之精，主天王正位。',
    lordLore: '心宿中央大火星（Antares）是全天最著名红星，《诗经》「七月流火」即指它西沉。月狐属阴精而机敏，狐善择穴而居，喻天王居中审察、明察秋毫。'
  },
  {
    name: '尾',
    lord: '尾火虎',
    group: '东方青龙',
    from: 256.156,
    obj: 'CON chinese-28 020',
    sum: '青龙之尾，九星曲折如钩，主后妃与子孙。',
    lordSum: '东方青龙第六宿星君，火虎之精，主九子之宫。',
    lordLore: '尾宿九星蜿蜒如龙尾摆动，古称「九子星」，占后宫子孙之事。火虎烈而威，虎行生风，喻龙尾摆处风雷随之。'
  },
  {
    name: '箕',
    lord: '箕水豹',
    group: '东方青龙',
    from: 271.261,
    obj: 'CON chinese-28 008',
    sum: '青龙末宿，四星如簸箕，主八风与口舌。',
    lordSum: '东方青龙末宿星君，水豹之精，主箕风调顺。',
    lordLore: '箕宿四星四角如簸箕，「箕星好风」，民间「箕伯」即风神。水豹潜行深水而疾，喻风自幽谷来、无形而有力。'
  },
  {
    name: '斗',
    lord: '斗木獬',
    group: '北方玄武',
    from: 280.181,
    obj: 'CON chinese-28 005',
    sum: '玄武首宿，六星如斗杓南指，主量度与爵禄。',
    lordSum: '北方玄武首宿星君，木獬之精，主南斗注生。',
    lordLore: '斗宿六星形似斗杓，与北斗相映称「南斗」，道教「南斗注生、北斗注死」之说源于此。木獬即獬豸，能辨曲直，喻斗宿量度分明、爵禄公平。'
  },
  {
    name: '牛',
    lord: '牛金牛',
    group: '北方玄武',
    from: 304.047,
    obj: 'CON chinese-28 016',
    sum: '玄武次宿，主牺牲祭祀与关梁，织女星在其北。',
    lordSum: '北方玄武次宿星君，金牛之精，主牺牲关梁。',
    lordLore: '牛宿古称「牵牛」，与隔银河相望的织女星构成七夕故事的天文底本。金牛负重致远，金性坚刚，占「祭祀牺牲、桥道通行」之事。'
  },
  {
    name: '女',
    lord: '女土蝠',
    group: '北方玄武',
    from: 311.723,
    obj: 'CON chinese-28 017',
    sum: '玄武第三宿，四星如簸箕缺角，主嫁娶与布帛。',
    lordSum: '北方玄武第三宿星君，土蝠之精，主娶妇布帛。',
    lordLore: '女宿古称「婺女」，主民间嫁娶、裁制之事。土蝠倒悬而眠、昼伏夜出，土性安静，喻女功于幽处成事、无声而有序。'
  },
  {
    name: '虚',
    lord: '虚日鼠',
    group: '北方玄武',
    from: 323.395,
    obj: 'CON chinese-28 024',
    sum: '玄武第四宿，二星相对如虚堂，主虚耗与丧事。',
    lordSum: '北方玄武第四宿星君，日鼠之精，主虚堂耗亡。',
    lordLore: '虚宿居冬至点附近，是「阳气初动于至虚」之地，故以「虚」为名。日鼠机敏藏于穴，昼伏夜动，喻虚中藏实、冬至一阳生。'
  },
  {
    name: '危',
    lord: '危月燕',
    group: '北方玄武',
    from: 333.352,
    obj: 'CON chinese-28 019',
    sum: '玄武第五宿，三星如危屋高檐，主宫室与险厄。',
    lordSum: '北方玄武第五宿星君，月燕之精，主危屋高台。',
    lordLore: '危宿三星如高屋之檐，取「危而不倾」之戒。月燕翔于檐下、知时节而返，喻居高危而守静、知机而不坠。'
  },
  {
    name: '室',
    lord: '室火猪',
    group: '北方玄武',
    from: 353.486,
    obj: 'CON chinese-28 018',
    sum: '玄武第六宿，二星如宫室，主营室建造与土功。',
    lordSum: '北方玄武第六宿星君，火猪之精，主营室土功。',
    lordLore: '室宿古称「营室」，《礼记》「孟春之月日在营室」——营建宫室必候此月。火猪掘土能构巢穴，喻土木大兴、安居之本。'
  },
  {
    name: '壁',
    lord: '壁水貐',
    group: '北方玄武',
    from: 9.156,
    obj: 'CON chinese-28 002',
    sum: '玄武末宿，二星如东壁，主文章图书。',
    lordSum: '北方玄武末宿星君，水貐之精，主东壁图书。',
    lordLore: '壁宿与室宿相连如宫室之东西壁，古称「东壁」，天下图书之秘府——「壁奎之间藏书府」。水貐爪利善掘，喻开卷得泉、文思涌出。'
  },
  {
    name: '奎',
    lord: '奎木狼',
    group: '西方白虎',
    from: 22.376,
    obj: 'CON chinese-28 012',
    sum: '白虎首宿，十六星如破鞋底，主文章武备。',
    lordSum: '西方白虎首宿星君，木狼之精，主奎文武库。',
    lordLore: '奎宿十六星纵横如文字之画，古以奎主文章，「奎星阁」由此得名（后讹作魁星）。木狼群体而猎、号令严明，喻白虎之首、兵众之统。'
  },
  {
    name: '娄',
    lord: '娄金狗',
    group: '西方白虎',
    from: 33.97,
    obj: 'CON chinese-28 014',
    sum: '白虎第二宿，三星如聚众，主牧养与聚众。',
    lordSum: '西方白虎第二宿星君，金狗之精，主娄聚牧养。',
    lordLore: '《史记》「娄为聚众」，占祭祀聚众、牧苑之事。金狗守夜而忠，嗅觉无遗，喻聚众有纪、牧养有守。'
  },
  {
    name: '胃',
    lord: '胃土雉',
    group: '西方白虎',
    from: 48.204,
    obj: 'CON chinese-28 021',
    sum: '白虎第三宿，三星如胃囊，主仓廪储积。',
    lordSum: '西方白虎第三宿星君，土雉之精，主胃藏仓廪。',
    lordLore: '胃为受纳之府，胃宿占天仓——「胃为天廪」，秋收所积皆归之。土雉栖于田畴、知谷之熟，喻仓廪实而知时节。'
  },
  {
    name: '昴',
    lord: '昴日鸡',
    group: '西方白虎',
    from: 59.412,
    obj: 'CON chinese-28 015',
    sum: '白虎第四宿，七星簇如明珠团，主狱事与胡星。',
    lordSum: '西方白虎第四宿星君，日鸡之精，主昴晓狱讼。',
    lordLore: '昴宿即昴星团（Pleiades），「昴星团如眼」——各族神话皆以七姊妹名之。日鸡司晨报晓，喻日精当空、晦暗自明，占狱讼察决之事。'
  },
  {
    name: '毕',
    lord: '毕月乌',
    group: '西方白虎',
    from: 68.465,
    obj: 'CON chinese-28 001',
    sum: '白虎第五宿，八星如捕兔长柄网，主边兵与雨候。',
    lordSum: '西方白虎第五宿星君，月乌之精，主毕罗边兵。',
    lordLore: '毕为捕兔长柄网，「毕星好雨」，月离于毕为雨候；毕昴之间的天关客星即 1054 年超新星（今蟹状星云）。月乌即月中三足乌，栖于网罗之侧，喻天网恢恢、雨泽有度。'
  },
  {
    name: '觜',
    lord: '觜火猴',
    group: '西方白虎',
    from: 83.707,
    obj: 'CON chinese-28 028',
    sum: '白虎第六宿，三星近参如虎首，古距度最小。',
    lordSum: '西方白虎第六宿星君，火猴之精，主觜觽储用。',
    lordLore: '觜即鸱吻之嘴，三星紧依参宿如虎口上颚，传统距度仅半度、为二十八宿之最。火猴跳跃灵变，喻口喙启处号令疾出。'
  },
  {
    name: '参',
    lord: '参水猿',
    group: '西方白虎',
    from: 84.681,
    obj: 'CON chinese-28 003',
    sum: '白虎末宿，三星一线为虎腰，猎户座主体，主斩伐。',
    lordSum: '西方白虎末宿星君，水猿之精，主参衡斩伐。',
    lordLore: '参宿即猎户座腰带三星，「参」通「叁」，古以三星夜半中天定冬至。水猿即无支祁类水怪、力能制水，喻白虎持衡、刑杀有度。'
  },
  {
    name: '井',
    lord: '井木犴',
    group: '南方朱雀',
    from: 95.302,
    obj: 'CON chinese-28 010',
    sum: '朱雀首宿，八星如井栏，全天最大宿区，主水事。',
    lordSum: '南方朱雀首宿星君，木犴之精，主东井水衡。',
    lordLore: '井宿跨区极广，北河、南河、天狼皆在其内——「井为玉井」，主泉水酒事。木犴即狱犬（犴狱同源），守于井边，喻法度如泉、取之有节。'
  },
  {
    name: '鬼',
    lord: '鬼金羊',
    group: '南方朱雀',
    from: 125.728,
    obj: 'CON chinese-28 007',
    sum: '朱雀第二宿，四星如舆，中央积尸气即蜂巢星团。',
    lordSum: '南方朱雀第二宿星君，金羊之精，主鬼舆祠祀。',
    lordLore: '鬼宿中央积尸气（M44 蜂巢星团）「白如粉絮」，古人视为天目、主死丧祠祀。金羊性温而群体有序，喻幽明之隔有常、祀之以礼。'
  },
  {
    name: '柳',
    lord: '柳土獐',
    group: '南方朱雀',
    from: 130.304,
    obj: 'CON chinese-28 013',
    sum: '朱雀第三宿，八星弯曲如鸟喙，主厨膳饮食。',
    lordSum: '南方朱雀第三宿星君，土獐之精，主柳厨膳食。',
    lordLore: '柳宿八星曲垂如朱雀之喙，古称「咮」，主御膳酒食——「柳为鸟注，主草木」。土獐善择草而食，喻膳羞有源、仓厨丰洁。'
  },
  {
    name: '星',
    lord: '星日马',
    group: '南方朱雀',
    from: 147.279,
    obj: 'CON chinese-28 023',
    sum: '朱雀第四宿，七星如衣裳领口，主衣裳文绣。',
    lordSum: '南方朱雀第四宿星君，日马之精，主星衣文绣。',
    lordLore: '星宿七星排如朱雀颈项领口，主后妃衣裳、文绣染彩。日马奔行不倦、日行千里，喻文采焕发、泽被四方。'
  },
  {
    name: '张',
    lord: '张月鹿',
    group: '南方朱雀',
    from: 155.691,
    obj: 'CON chinese-28 026',
    sum: '朱雀第五宿，六星张如弓，主珍宝宗庙。',
    lordSum: '南方朱雀第五宿星君，月鹿之精，主张珍宗庙。',
    lordLore: '张宿六星形如张开之弓，朱雀嗉囊所在，主宗庙珍宝、天厨饮食。月鹿性洁栖于林，喻宗庙祭品洁净、珍馐有节。'
  },
  {
    name: '翼',
    lord: '翼火蛇',
    group: '南方朱雀',
    from: 173.689,
    obj: 'CON chinese-28 025',
    sum: '朱雀第六宿，二十二星如鸟翼，全天大宿，主乐律。',
    lordSum: '南方朱雀第六宿星君，火蛇之精，主翼羽乐律。',
    lordLore: '翼宿二十二星展开如朱雀张翼，为二十八宿星数之最，主乐律俳优——「翼主天倡」。火蛇无足而行疾，喻乐声蜿蜒远播、舞袖如翼。'
  },
  {
    name: '轸',
    lord: '轸水蚓',
    group: '南方朱雀',
    from: 190.726,
    obj: 'CON chinese-28 027',
    sum: '朱雀末宿，四星如车舆，主车骑丧葬。',
    lordSum: '南方朱雀末宿星君，水蚓之精，主轸舆车骑。',
    lordLore: '轸为车后横木，轸宿四星如车舆之底，左辖右辖二星夹之如车耳，主车骑征战与丧事。水蚓行于地下而通泉脉，喻车行万里、脉络通达。'
  }
]

// 十二星次：from = 次起点太阳黄经（节气），sign = 对应西方占星十二宫。
// [guanxing patch] M-SW53：qi = 太阳行经节气区间（from 节 → 次次 from 节）；
// sum/lore = 星次独属文化介绍（弹窗行内摘要用 sum，知识栏星次块用 sum+lore）。
// [guanxing patch] M-SW62（用户需求「星次展示的星星连线 要是真实的星次的星星连线
// 或者 虚线框包围起来」）：mansions = 该星次所含二十八宿（**本仓正文口径**，与
// 上面 sum/lore 已上线的星次文案逐条自洽；星纪/玄枵两行原文未点名宿，按通行
// 「十二次分野」表补全）。12 组必须**恰好划分** 28 宿（无重无漏，qa 断言钉死），
// 是 pipeline/build-skyculture-xingci.mjs 生成「真实星次连线 + 虚线包围框」的唯一
// 权威口径——该脚本动态 import 本表，不另存第二份映射。
export const XINGCI = [
  {
    name: '星纪',
    from: 255,
    sign: '摩羯座',
    qi: '大雪—小寒',
    mansions: ['斗', '牛'],
    obj: 'CON chinese-xingci 001',
    sum: '十二星次之首，日月五星的起算点，含冬至，岁序之始。',
    lore: '「星纪」者，以星纪岁——日月五星周年运行以此为纪。星纪次含冬至点（古测），太阳行至此处回环折返，昼始渐长，故旧岁新年在此交替；《汉书·律历志》即以星纪为十二次之首。'
  },
  {
    name: '玄枵',
    from: 285,
    sign: '宝瓶座',
    qi: '小寒—立春',
    mansions: ['女', '虚', '危'],
    obj: 'CON chinese-xingci 002',
    sum: '颛顼之虚，北陆之次，虚空之中藏养生机。',
    lore: '「玄枵」之枵即空虚，本指北方玄武虚宿一带的天区，又是颛顼帝之虚（帝都分野）。仲冬寒极、万物敛藏，古人于至虚至暗中见生意——玄枵正是「虚中生元」之次。'
  },
  {
    name: '娵訾',
    from: 315,
    sign: '双鱼座',
    qi: '立春—惊蛰',
    mansions: ['室', '壁'],
    obj: 'CON chinese-xingci 003',
    sum: '营室东壁之次，孟春日在营室，阳气初生。',
    lore: '娵訾为室宿、壁宿之次，《礼记·月令》孟春之月「日在营室」——立春前后太阳行经此次，蛰虫始振、万物始动。娵訾本是神话中溟海之滨的地名，用作星次取「阳气初生于幽冥之滨」之意。'
  },
  {
    name: '降娄',
    from: 345,
    sign: '白羊座',
    qi: '惊蛰—清明',
    mansions: ['奎', '娄'],
    obj: 'CON chinese-xingci 004',
    sum: '奎娄之次，阳气下降而万物相聚萌出。',
    lore: '降娄为奎宿、娄宿之次，《史记·天官书》「娄为聚众」——仲春阳气普降、万物萌出相聚，故曰降娄。其分野为鲁地，《左传》「降娄中而旦」即是记鲁国观象授时。'
  },
  {
    name: '大梁',
    from: 15,
    sign: '金牛座',
    qi: '清明—立夏',
    mansions: ['胃', '昴', '毕'],
    obj: 'CON chinese-xingci 005',
    sum: '胃昴毕之次，白虎中段，天关如梁横跨黄道。',
    lore: '大梁为胃、昴、毕三宿之次，居西方白虎七宿中段。「梁」取强梁、桥梁之义——昴毕之间的天关横跨黄道，日月五星由此出入；其分野为赵地，应强梁雄武之象。'
  },
  {
    name: '实沈',
    from: 45,
    sign: '双子座',
    qi: '立夏—芒种',
    mansions: ['觜', '参'],
    obj: 'CON chinese-xingci 006',
    sum: '参宿之次，高辛氏之子主参星，「参商永离」典故所在。',
    lore: '实沈为参宿之次。高辛氏二子日寻干戈，帝迁其一于大夏主参、其一于商丘主辰——自此参、心二星此出彼没永不相见，杜甫「人生不相见，动如参与商」即用此典。'
  },
  {
    name: '鹑首',
    from: 75,
    sign: '巨蟹座',
    qi: '芒种—小暑',
    mansions: ['井', '鬼'],
    obj: 'CON chinese-xingci 007',
    sum: '井鬼之次，朱雀头颈，秦之分野。',
    lore: '南方朱雀七宿分属鹑首、鹑火、鹑尾三次：鹑首居井、鬼二宿，是朱雀的头颈。井宿主水事、鬼宿主祠祀；其分野为秦地关中，《汉书》即以鹑首应秦之象。'
  },
  {
    name: '鹑火',
    from: 105,
    sign: '狮子座',
    qi: '小暑—立秋',
    mansions: ['柳', '星', '张'],
    obj: 'CON chinese-xingci 008',
    sum: '柳星张之次，朱雀之心，周之分野。',
    lore: '鹑火居柳、星、张三宿，是朱雀的心脏，故以「火」为名。其分野为周室王畿——《国语》记武王伐纣「星在鹑火」，鹑火因此成为周人受命之次，居中得正。'
  },
  {
    name: '鹑尾',
    from: 135,
    sign: '室女座',
    qi: '立秋—白露',
    mansions: ['翼', '轸'],
    obj: 'CON chinese-xingci 009',
    sum: '翼轸之次，朱雀尾羽，楚之分野。',
    lore: '鹑尾居翼、轸二宿，是朱雀的尾羽。翼宿主乐律、轸宿主车驾；其分野为楚地，屈子所歌之郢都即应鹑尾之次。'
  },
  {
    name: '寿星',
    from: 165,
    sign: '天秤座',
    qi: '白露—霜降',
    mansions: ['角', '亢'],
    obj: 'CON chinese-xingci 010',
    sum: '角亢之次，南极老人星当空，主长寿安宁。',
    lore: '寿星为角、亢二宿之次。秋分之后南极老人星于南方低空显现，古人尊为南极寿星，主天下寿考安宁；《史记·封禅书》列寿星为祠——今日「寿星」祝寿之称即源于此次。'
  },
  {
    name: '大火',
    from: 195,
    sign: '天蝎座',
    qi: '寒露—立冬',
    mansions: ['氐', '房', '心'],
    obj: 'CON chinese-xingci 011',
    sum: '氐房心之次，心宿二即大火星，「七月流火」之火。',
    lore: '大火为氐、房、心三宿之次，心宿二（天蝎座红色亮星 Antares）即古之「大火」。《诗经》「七月流火」言大火西沉而暑退将寒；高辛氏之子阏伯迁于商丘主此星，商丘火神台至今犹存，是中国最早的观星台之一。'
  },
  {
    name: '析木',
    from: 225,
    sign: '人马座',
    qi: '立冬—大雪',
    mansions: ['尾', '箕'],
    obj: 'CON chinese-xingci 012',
    sum: '尾箕之次，银河之滨的「析木之津」，燕之分野。',
    lore: '析木为尾、箕二宿之次，正当银河之滨，古称「析木之津」——析即分，指天河分界之津渡。其分野为燕地；箕宿主风、尾宿主云雾，东北边塞风云之象皆归此次。'
  }
]

// [guanxing patch] M-SW53：十二星座一句话独属摘要（星命弹窗「星座」行内展示）。
// 键 = App.vue ZODIAC_SIGNS 的 zh 中文名（与 XINGCI.sign 同一套译名口径）。
export const ZODIAC_SUMMARY = {
  白羊座: '黄道第一宫，春分点古所在，金羊毛神话中的神羊。',
  金牛座: '胃昴毕所在，宙斯化身白牛渡欧罗巴；昴星团是牛肩明珠。',
  双子座: '孪生兄弟卡斯托与波吕克斯，一神一凡、生死与共。',
  巨蟹座: '黄道最暗一宫，中央蜂巢星团古称「积尸气」，赫拉克勒斯之战中的神蟹。',
  狮子座: '赫拉克勒斯十二功绩之首的尼米亚狮子，狮心轩辕十四为黄道最亮之星。',
  室女座: '全天第二大星座，主星角宿一即中国角宿之距星，丰收女神之象。',
  天秤座: '正义之秤，秋分昼夜均分时正当空，黄道唯一非生物之象。',
  天蝎座: '红心大火星（Antares）与猎户遥遥相对，蜇杀猎户的毒蝎，永世不得同天。',
  人马座: '半人马贤者喀戎张弓，弓箭直指银河系中心方向。',
  摩羯座: '羊身鱼尾的山神潘，冬至点古所在——一年最幽暗处的光明起点。',
  宝瓶座: '众神斟酒者甘尼美提斯，倾倒的宝瓶流成秋季的天河。',
  双鱼座: '爱与美之神母子化鱼逃生，以丝带相连，春分点现所在。'
}

// 环形区间查找：from[i] ≤ lon < from[i+1]（wrap）。两表起点均沿序单调。
export function lunarMansionOf (lon) {
  const L = LUNAR_MANSIONS
  for (let i = 0; i < L.length; i++) {
    const a = L[i].from
    const b = L[(i + 1) % L.length].from
    if (a < b ? (lon >= a && lon < b) : (lon >= a || lon < b)) return L[i]
  }
  return L[0]
}

export function xingciOf (lon) {
  const L = XINGCI
  for (let i = 0; i < L.length; i++) {
    const a = L[i].from
    const b = L[(i + 1) % L.length].from
    if (a < b ? (lon >= a && lon < b) : (lon >= a || lon < b)) return L[i]
  }
  return L[0]
}
